<template>
  <div class="table-container table-scroll group-list">
    <table class="table">
      <tbody>
      <tr v-for="(item, index) in data" :key="index">
        <th>{{ index+1 }}</th>
        <th class="text-overflow">
          {{ item.name }}
        </th>
        <th class="text-right">
          <input
              v-model="item.quantity"
              name="quantity"
              type="number"
              class="form-control text-right"
              @input="changeQty(item.quantity, index)"
          />
        </th>
        <th class="text-right">
          <input
              v-model="item.rate"
              name="quantity"
              type="number"
              class="form-control text-right"
          />
        </th>
        <th class="text-right">
          <input
              type="text"
              class="form-control text-right"
              :value="item.rate * item.quantity"
              readonly
          />
        </th>
        <th>
          <span class="cursor-pointer" @click="deleteTableItem(index)">X</span>
        </th>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script setup>
const props = defineProps({
  data: {
    type: Array,
    required: true,
  },
});
const emit = defineEmits(['changeQty', 'deleteTableItem']);

const changeQty = (quantity, index) => {
  emit('changeQty', quantity, index);
}
const deleteTableItem = (index) => {
  emit('deleteTableItem', index);
}
</script>
<style scoped>
.table-scroll {
  height: 300px !important;
}
.group-list {
  overflow-y: auto;
  overflow-x: hidden;
}
.group-list::-webkit-scrollbar {
  width: 4px;
}

.group-list::-webkit-scrollbar-track {
  background: transparent;
}

.group-list::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.25);
  border-radius: 10px;
}
</style>